import { render, staticRenderFns } from "./DiarioListModal.vue?vue&type=template&id=b1315804&scoped=true"
import script from "./DiarioListModal.vue?vue&type=script&lang=js"
export * from "./DiarioListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1315804",
  null
  
)

export default component.exports